<template>
  <a-dialog
    ref="dialog"
    name="api_token_created"
    size="small"
    @open="opened"
    @close="$reset"
    :close-action="false"
  >
    <span slot="title">{{ $t('title') }}</span>
    <div slot="content">
      {{ $t('text') }}
      <v-text-field :value="token" @focus="$event.target.select()"></v-text-field>
    </div>
    <span slot="actions">
      <v-btn color="blue darken-1" text @click="close">
        {{ $t('actions.close') }}
      </v-btn>
    </span>
  </a-dialog>
</template>

<script>
export default {
  name: 'ApiTokenCreatedDialog',
  data () {
    return {
      token: ''
    }
  },
  methods: {
    opened ({ token }) {
      this.token = token
    },
    close () {
      if (this.$refs.dialog) this.$refs.dialog.close()
    }
  }
}
</script>

<i18n>
{
	"en": {
		"text": "Your new token has been successfully created. Copy and save the key below as it cannot be viewed again.",
		"title": "Api Token Created"
	},
	"es": {
		"text": "Su nuevo token se ha creado correctamente. Copie y guarde la clave a continuación, no se puede ver más tarde.",
		"title": "Token de API creado"
	},
	"fr": {
		"text": "Votre nouveau token a été créé avec succès. Copiez et enregistrez la clé ci-dessous, elle ne pourra plus être consultée ultérieurement.",
		"title": "Token d'Api créé"
	},
	"it": {
		"text": "Il tuo nuovo token è stato creato con successo. Copia e salva la chiave qui sotto poiché non potrà essere visualizzata di nuovo.",
		"title": "Token Api Creato"
	},
	"pt": {
		"text": "O seu novo token foi criado com sucesso. Copie e guarde a chave abaixo pois não poderá ser visualizada novamente.",
		"title": "Token Api Criado"
	},
	"pl": {
		"text": "Twój nowy token został pomyślnie utworzony. Skopiuj i zapisz klucz poniżej, ponieważ nie będzie można go ponownie wyświetlić.",
		"title": "Token Api Utworzony"
	}
}
</i18n>

